import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import styles from './EmailVerificationSuccess.module.scss';
import { Button } from '@src/components/ui';
const EmailVerificationSuccess = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { verifyEmail } = useAuth();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [verified, setVerified] = useState(false);
    const token = searchParams.get('token');
    const uid = searchParams.get('uid');
    const success = searchParams.get('success');
    const errorParam = searchParams.get('error');
    useEffect(() => {
        // Handle direct verification (old flow)
        if (token && uid) {
            setLoading(true);
            verifyEmail(token, uid).then((res) => {
                if (res.success) {
                    setVerified(true);
                }
                else {
                    setError(res.message || 'Could not verify email.');
                }
                setLoading(false);
            });
        }
        // Handle redirect from backend (new flow)
        else if (success === 'true') {
            setVerified(true);
        }
        else if (errorParam) {
            switch (errorParam) {
                case 'missing_params':
                    setError('Missing verification parameters.');
                    break;
                case 'expired':
                    setError('Verification link has expired. Please request a new one.');
                    break;
                case 'invalid':
                    setError('Invalid verification link.');
                    break;
                default:
                    setError('Verification failed. Please try again.');
            }
        }
    }, [token, uid, success, errorParam, verifyEmail]);
    if (loading) {
        return _jsx("p", { className: styles.loading, children: "Verifying your email..." });
    }
    return (_jsxs("div", { className: styles.verificationSuccessWrapper, children: [verified && (_jsxs("div", { className: styles.successBanner, children: [_jsx("span", { className: styles.checkmark, children: "\u2713" }), "Your email has been verified!"] })), _jsx("div", { className: styles.headingContainer, children: verified ? (_jsxs(_Fragment, { children: [_jsx("h3", { children: "You're all set!" }), _jsx("p", { children: "You verified your account! Now set up your clinic." }), _jsx("div", { className: styles.buttonContainer, children: _jsx(Button, { variant: "secondaryV2", label: "Setup Clinic", onClick: () => navigate(`/account/createClinic?uid=${uid}`), className: styles.setupButton }) })] })) : (_jsxs(_Fragment, { children: [_jsx("h3", { children: "Verification Failed" }), _jsx("p", { className: styles.error, children: error })] })) })] }));
};
export default EmailVerificationSuccess;
